import { classNames } from "@/react/helpers/twMergeWithCN";

export interface MentionChipProps {
  className?: string;
  name: string;
}

export const MentionChip = ({ className, name }: MentionChipProps) => (
  <span
    contentEditable={false}
    className={classNames("text-link cursor-pointer font-medium", className)}
  >
    {name}
  </span>
);
